import { render, staticRenderFns } from "./HrInsights.vue?vue&type=template&id=e2f21880&scoped=true"
import script from "./HrInsights.vue?vue&type=script&lang=js"
export * from "./HrInsights.vue?vue&type=script&lang=js"
import style0 from "./HrInsights.vue?vue&type=style&index=0&id=e2f21880&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2f21880",
  null
  
)

export default component.exports